import i18n from '@/i18n';
import {UnitType} from '@/services/graphqlHooks';

const unitType = {
  [UnitType.Mg]: i18n.t('mg'),
  [UnitType.Mcg]: i18n.t('mcg'),
  [UnitType.G]: i18n.t('g'),
  [UnitType.Ml]: i18n.t('ml'),
  [UnitType.L]: i18n.t('l'),
  [UnitType.Unit]: i18n.t('unit'),
  [UnitType.Tablet]: i18n.t('tablet'),
  [UnitType.Capsule]: i18n.t('capsule'),
  [UnitType.Drop]: i18n.t('drop'),
  [UnitType.Patch]: i18n.t('patch'),
  [UnitType.Suppository]: i18n.t('suppository'),
  [UnitType.Sachet]: i18n.t('sachet'),
  [UnitType.Puff]: i18n.t('puff'),
  [UnitType.Spray]: i18n.t('spray'),
  [UnitType.Ampoule]: i18n.t('ampoule'),
  [UnitType.Injection]: i18n.t('injection'),
  [UnitType.Percent]: i18n.t('%'),
  [UnitType.Application]: i18n.t('application'),
} as Record<UnitType, string>;

export default unitType;
